import { ReactNode } from "react";
import { normalizarFilasBitacoraCotizacion } from "./bitacoraCotizacionNormalizar.utils";

type FilaNormalizada = ReturnType<typeof normalizarFilasBitacoraCotizacion>[number];

interface ReglaAgrupacion {
    clave: string;
    coincide: (fila: FilaNormalizada) => boolean;
    titulo: (cantidad: number) => string;
}

const REGLAS_AGRUPACION: ReglaAgrupacion[] = [
    {
        clave: "seleccionado",
        coincide: (f) => /producto.*seleccionad/i.test(f.titulo),
        titulo: (n) => (n === 1 ? "Producto seleccionado" : `${n} productos seleccionados`),
    },
    {
        clave: "rechazado",
        coincide: (f) => /producto.*rechazad/i.test(f.titulo),
        titulo: (n) => (n === 1 ? "Producto rechazado" : `${n} productos rechazados`),
    },
    {
        clave: "autorizado",
        coincide: (f) => /producto.*autorizad/i.test(f.titulo),
        titulo: (n) => (n === 1 ? "Producto autorizado" : `${n} productos autorizados`),
    },
];

export interface FilaBitacoraVista extends FilaNormalizada {
    claveGrupo: string | null;
    detalles: ReactNode[];
    agrupada: boolean;
}

export const agruparFilasBitacoraCotizacion = (filas: FilaNormalizada[]): FilaBitacoraVista[] => {
    const resultado: FilaBitacoraVista[] = [];

    filas.forEach((fila) => {
        const regla = REGLAS_AGRUPACION.find((r) => r.coincide(fila)) ?? null;
        const anterior = resultado[resultado.length - 1];

        const mismoGrupo =
            regla !== null &&
            anterior?.claveGrupo === regla.clave &&
            anterior.nombreUsuario === fila.nombreUsuario;

        if (mismoGrupo) {
            anterior.detalles.push(fila.descripcion);
            anterior.agrupada = true;
            anterior.titulo = regla.titulo(anterior.detalles.length);
            return;
        }

        resultado.push({
            ...fila,
            claveGrupo: regla?.clave ?? null,
            detalles: [fila.descripcion],
            agrupada: false,
        });
    });

    return resultado.map((fila, i) => ({
        ...fila,
        esPrimero: i === 0,
        esUltimo: i === resultado.length - 1,
    }));
};